import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia en meditación o mindfulness?',
  a: 'No. El método está diseñado para personas que nunca han meditado. Todo es paso a paso, sin tecnicismos.'
}, {
  q: '¿Cuánto tiempo necesito por noche?',
  a: 'Entre 10 y 20 minutos. Nada más. Está diseñado para mujeres con poco tiempo y mucha energía mental acumulada.'
}, {
  q: '¿Funciona si mi problema es que me despierto en la madrugada (no que me cuesta dormirme)?',
  a: 'Sí. La Noche 4 está dedicada exactamente a eso: el protocolo paso a paso para volver a dormirte cuando te despiertas a las 3am.'
}, {
  q: '¿En qué formato está el producto?',
  a: 'Es un PDF de 36 páginas descargable. Lo recibes por email inmediatamente después de la compra y puedes leerlo en tu teléfono, tablet o computadora.'
}, {
  q: '¿Qué pasa si no funciona para mí?',
  a: 'Tienes 7 días de garantía total. Si sientes que no valió la pena, te devuelvo el 100% sin preguntas.'
}, {
  q: '¿Es para cualquier edad?',
  a: 'Está especialmente diseñado para mujeres de 28 a 48 años con ritmo de vida activo y alta carga mental. Pero si te identificas con el problema, funciona independientemente de tu edad.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-[#FDFBFF] py-16 md:py-24 px-4 md:px-6" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <FadeIn data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-10 md:mb-16" data-id="element-38">
            Preguntas frecuentes:
          </h2>
        </FadeIn>

        <div className="space-y-3 md:space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-40">
              <div className="bg-white rounded-2xl border border-purple-100 hover:border-purple-200 overflow-hidden transition-colors" data-id="element-41">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-42">
                  <span className="font-medium text-night-900 pr-4 md:pr-8 text-sm md:text-base" data-id="element-43">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-44" />
                </button>
                <div className={`px-4 md:px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 md:pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-45">
                  <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-46">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}